// extracted by mini-css-extract-plugin
export var formContainer = "_mj-0";
export var message = "_mj-1";